<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('declarationTlpe.title') }}
              </h1>
              <breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-action
              @handleAction="handleAction"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="getAllCollectiviteSelected().length > 0"
            ></selecteur-action>
          </div>
          <form @submit.prevent="recherche()" class="column is-3 pdl-0 pdr-0">
            <b-input :placeholder="$t('declarationTlpe.actions.search')"
                     type="search"
                     icon="magnify"
                     v-model="allCriteresRecherche.auto">
            </b-input>
          </form>
          <div class='column is-narrow'>
            <button class="button" @click='setShowFiltre'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">
                {{$t('declarationTlpe.actions.filtre')}}
                <label class="has-text-weight-bold"
                       :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiserFiltre()"
                  class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="level-right columns">
        <div class="column is-narrow">
          <b-field :label="$t('declarationTlpe.year')"/>
        </div>
        <div class="column is-narrow">
          <b-select v-model="anneeDeclaration" expanded @input="recherche">
            <option v-for="year in yearRange"
                    :key="year"
                    :value="year">
              {{year}}
            </option>
          </b-select>
        </div>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <a ref="lienDownload"></a>
    <v-server-table url="" :columns="columns" :options="options" :ref="referenceTable"
                    @loaded="finLoading" @loading="debutLoading" v-if="startArrayRendering">
      <div slot="code" slot-scope="props">
          {{ props.row.code }}
      </div>
      <div slot="nomCommercial" slot-scope="props">
        <router-link-blank :to="{ name: 'c.gabed.collectivite',
                                      params: { id: props.row.id }}"
                           class="lien"
                           :message="props.row.nomCommercial">
        </router-link-blank>
      </div>
      <div slot="selected" slot-scope="props" class="has-text-centered">
        <b-checkbox v-model="props.row.selected"/>
      </div>
      <div slot="nombreMaterielPresentsAnnee" slot-scope="props" class="has-text-centered">
        {{ nombreMaterielPresentsAnnee(props.row) }}
      </div>
      <div slot="nombreMaterielDemonteAnneePrec" slot-scope="props" class="has-text-centered">
        {{ nombreMaterielDemonteAnneePrec(props.row) }}
      </div>
      <div slot="nombreMaterielMonteAnneePrec" slot-scope="props" class="has-text-centered">
        {{ nombreMaterielMonteAnneePrec(props.row) }}
      </div>
      <div slot="materiel" slot-scope="props">
        <b-tooltip :label="$t('declarationTlpe.messages.info.materielParCollectivite',
        { nom: props.row.nomCommercial})"
                   position="is-left">
          <router-link-blank :to="{ name: 'l.gabed.materielTlpe',
                              params: { id: props.row.id }}"
                             icon="billboard"
                             typeIcon="is-primary"
                             :message="props.row.nomCommercial">
          </router-link-blank>
        </b-tooltip>
      </div>
      <div slot="commandes" slot-scope="props" class="has-text-centered">
        <div v-if="props.row.commandes && props.row.commandes.length === 1">
          <router-link-blank :to="{ name: 'c.gabed.commande_tlpe',
                                      params: { id: props.row.commandes[0].id }}"
                             class="lien"
                             :message="props.row.commandes[0].code">
          </router-link-blank>
        </div>
        <div v-else-if="props.row.commandes && props.row.commandes.length > 1">
          <router-link-blank :to="{ name: 'l.gabed.commande_tlpe',
                                    params: {
                                      tiersId: props.row.id,
                                      annee: anneeDeclaration,
                                      isFilDeLeau: false,
                                    }}"
                             class="lien"
                             :message="props.row.commandes.length.toString()">
          </router-link-blank>
        </div>
      </div>
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)"/>
      </template>
    </v-server-table>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-show="showFiltre">
        <filtre-collectivite :critere-recherche="allCriteresRecherche" ref="filtreListeDeclaration"
                             @toggleFiltre="setShowFiltre"
                             @recherche="makeRechercheFilter"/>
      </div>
      </transition>
    <b-modal v-model="displayPopupGenerationCommandesTlpe"
      has-modal-card class="modal" width="600px">
      <popup-generation-commande-tlpe
        :subtitle="{
            nbCollectivite: getAllCollectiviteSelected().length,
            year: anneeDeclaration
          }"
        :messagesErreurPopup="messagesErreurPopUp"
        :isErrorPopup.sync="errorPopUp"
        @generationCommandes="generationCommandes" />
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import breadcrumb from '@/components/general/breadcrumb';
import { MATERIEL_TLPE } from '@/configuration/gabed/permissionsGabedConf';
import TableItemsInView from '@/components/general/TableItemsInView';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import subscribeMutation from '@/services/store/subscribeMutation';
import messageErreur from '@/services/general/messageErreur';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import selecteurAction from '@/components/general/selecteurAction';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import filtreCollectivite from '@/components/gabed/collectivite/filtreCollectivite';
import { SET_CRITERE_RECHERCHE } from '@/store/modules/baux/paiementSurFacture-mutation-type';
import { ACTION_GENERATION_COMMANDES_TLPE, ACTION_IMPRESSION_COMMANDES_TLPE } from '@/configuration/gabed/tlpe/tlpeConf';
import popupGenerationCommandeTlpe from '@/components/gabed/materiel/popupGenerationCommandeTlpe';
import { generationDeclarationsTlpeAsync } from '@/api/gabed/materiel';
import validation from '@/services/gabed/declaration/validation';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import editionCerfaAsync from '@/services/gabed/commandeTlpe/editionCerfaCommandeTlpe';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_DECLARATIONS } from '@/configuration/general/referenceTableConf';

const Permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');
const Collectivite = createNamespacedHelpers('collectivite');

export default {
  data() {
    return {
      permMaterielTlpe: MATERIEL_TLPE,
      unsubscribeValue: null,
      showFiltre: false,
      actions: [
        { action: ACTION_GENERATION_COMMANDES_TLPE, translation: 'declarationTlpe.actions.generationCommandesTlpe' },
        { action: ACTION_IMPRESSION_COMMANDES_TLPE, translation: 'declarationTlpe.actions.impressionCommandesTlpe' },
      ],
      anneeDeclaration: new Date().getFullYear(),
      yearRange: [],
      displayPopupGenerationCommandesTlpe: false,
      messagesErreurPopUp: [],
      errorPopUp: false,
      referenceTable: REFERENCE_TABLE_DECLARATIONS,
      resultPerPage: RESULTS_PER_PAGE,
      startArrayRendering: false,
    };
  },
  components: {
    breadcrumb,
    TableItemsInView,
    selecteurAction,
    filtreCollectivite,
    popupGenerationCommandeTlpe,
    routerLinkBlank,
    parametrageTable,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      lockMenu: 'lockMenu',
    }),
    ...Collectivite.mapGetters({
      collectivite: 'items',
      total: 'total',
      allCriteresRecherche: 'criteresRecherche',
      lastPayload: 'lastPayload',
    }),
    breadcrumb() {
      return [
        { title: this.$i18n.t('declarationTlpe.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('declarationTlpe.breadcrumb.declarationsTLPE'), route: { name: 'l.gabed.collectivite' }, isActive: true },
      ];
    },
    nombreCritere() {
      const banCritereKey = ['auto', 'archive'];
      let nbCritere = calculNombreCritere(this.allCriteresRecherche, banCritereKey);
      nbCritere += this.allCriteresRecherche.archive !== null ? 1 : 0;
      return nbCritere > 9 ? '+9' : nbCritere;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          nomCommercial: this.$i18n.t('declarationTlpe.tab.nomCommercial'),
          compteComptable: this.$i18n.t('declarationTlpe.tab.compteComptable'),
          nombreMaterielPresentsAnnee: this.$i18n.t('declarationTlpe.tab.nbMaterielPresent'),
          nombreMaterielDemonteAnneePrec: this.$i18n.t('declarationTlpe.tab.nbDemontageAnPrec'),
          nombreMaterielMonteAnneePrec: this.$i18n.t('declarationTlpe.tab.nbMontageAnPrec'),
          commandes: this.$i18n.t('declarationTlpe.tab.commande'),
          materiel: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.query = cloneDeep(this.allCriteresRecherche);
          data.query.societeId = this.societeActiveId;
          data.year = this.anneeDeclaration;

          return this.actionLoadCollectivite(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.collectivite,
            count: this.total,
          };
        }),
        columnsClasses: {
          materiel: 'colonneSelected',
          selected: 'colonneSelected',
        },
        sortable: ['nomCommercial', 'compteComptable'],
      };
    },
    columns() {
      return [
        'selected',
        'nomCommercial',
        'compteComptable',
        'nombreMaterielPresentsAnnee',
        'nombreMaterielMonteAnneePrec',
        'nombreMaterielDemonteAnneePrec',
        'commandes',
        'materiel',
      ];
    },
    iconSelectTotal() {
      if (this.allCollectiviteSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    allCollectiviteSelected() {
      return this.getAllCollectiviteSelected().length === this.collectivite.length
        && this.collectivite.length > 0;
    },
  },
  beforeDestroy() {
    if (this.lockMenu) this.setLockMenu(false);
    this.unsubscribeValue();
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Collectivite.mapActions({
      actionLoadCollectivite: 'loadDeclaration',
    }),
    ...Collectivite.mapMutations({
      setCritereRecherche: SET_CRITERE_RECHERCHE,
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeDeclaration.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    async reinitialiserFiltre() {
      await this.$refs.filtreListeDeclaration.initializeFiltre();
      this.$refs.filtreListeDeclaration.viderCritere();
      this.$refs.filtreListeDeclaration.appliquerCritere();
      this.showFiltre = false;
    },
    getAllCollectiviteSelected() {
      return this.collectivite.filter((el) => {
        return el.selected;
      });
    },
    selectAll() {
      const select = !this.allCollectiviteSelected;
      this.collectivite.forEach(item => {
        item.selected = select;
      });
    },
    handleAction(action) {
      switch (action) {
        case ACTION_GENERATION_COMMANDES_TLPE:
          this.messagesErreurPopUp = [];
          this.errorPopUp = false;
          this.displayPopupGenerationCommandesTlpe = true;
          break;
        case ACTION_IMPRESSION_COMMANDES_TLPE:
          if (this.checkPermissions(this.permMaterielTlpe.editer)) {
            this.editionsCerfa();
          } else this.showPopUp();
          break;
        default:
          break;
      }
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    makeRechercheFilter(newFiltre) {
      this.setCritereRecherche(newFiltre);
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    nombreMaterielPresentsAnnee(row) {
      return row.nombreMaterielPresentsAnnee === 0 ? '' : row.nombreMaterielPresentsAnnee;
    },
    nombreMaterielDemonteAnneePrec(row) {
      return row.nombreMaterielDemonteAnneePrec === 0 ? '' : row.nombreMaterielDemonteAnneePrec;
    },
    nombreMaterielMonteAnneePrec(row) {
      return row.nombreMaterielMonteAnneePrec === 0 ? '' : row.nombreMaterielMonteAnneePrec;
    },
    async editionsCerfa() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const collectivites = this.getAllCollectiviteSelected();
        const commandesId = [];

        collectivites.forEach(collectivite => {
          if (collectivite.commandes == null) return;
          collectivite.commandes.forEach(commande => {
            commandesId.push(commande.id);
          });
        });
        if (commandesId.length > 0) await editionCerfaAsync(commandesId, this.$refs.lienDownload);
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    async generationCommandes(args) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorPopUp = false;
        this.messagesErreurPopUp = [];
        const collectivites = this.getAllCollectiviteSelected();
        const collectivitesIds = collectivites.map((collectivite) => {
          return collectivite.id;
        });
        const params = {
          societeId: this.societeActiveId,
          collectivitesIds: collectivitesIds,
          annee: this.anneeDeclaration,
          typeDeclaration: args.typeDeclaration,
          declarantId: args.userId,
        };
        await generationDeclarationsTlpeAsync(params);
        this.displayPopupGenerationCommandesTlpe = false;
        this.recherche();
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          validation(e.response, this.messagesErreurPopUp, []);
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
      }
    },
  },
  async mounted() {
    this.yearRange.push(this.anneeDeclaration - 5);
    this.yearRange.push(this.anneeDeclaration - 4);
    this.yearRange.push(this.anneeDeclaration - 3);
    this.yearRange.push(this.anneeDeclaration - 2);
    this.yearRange.push(this.anneeDeclaration - 1);
    this.yearRange.push(this.anneeDeclaration);
    this.yearRange.push(this.anneeDeclaration + 1);
    this.yearRange.push(this.anneeDeclaration + 2);

    const loadingComponent = this.$buefy.loading.open();
    try {
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPage);
      this.setInformationPage(this.$t('declarationTlpe.title'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>

<style scoped>

</style>
